query PurchaseOrderAccountingIntegrationAllowed {
  purchaseOrderAccountingIntegrationAllowed 
}
